import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import { es } from 'vuetify/lib/locale'
import preset from '@/@core/preset/preset'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },

  lang: {
    locales: { es }, // establece el idioma español
    current: 'es',
  },
})
